import React from 'react';
export function PromoBar() {
  return;
}